import { render, staticRenderFns } from "./r-tab.vue?vue&type=template&id=387d21da"
import script from "./r-tab.vue?vue&type=script&lang=js"
export * from "./r-tab.vue?vue&type=script&lang=js"
import style0 from "./r-tab.vue?vue&type=style&index=0&id=387d21da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports